module.exports = __webpack_public_path__ + "img/20201112-2.03cc419d.jpg";